module.exports = __webpack_public_path__ + "static/media/bursts_12.276121d3.svg";